import defaults from './tebraDefaults';

export const defaultButton = {
  backgroundColor: defaults.white,
  backgroundImage: 'none',
  border: `1px solid ${defaults.coreColor}`,
  boxShadow: 'none',
  color: defaults.primaryColor,
  svgColor: defaults.primaryColor,
  hover: {
    backgroundColor: defaults.coreColor100,
    backgroundImage: 'none',
  },
  active: {
    backgroundColor: defaults.coreColor100,
    boxShadow: 'none',
  },
  disabled: {
    backgroundColor: defaults.white,
    border: `1px solid ${defaults.coreColor100}`,
    color: defaults.primaryColor200,
    svgColor: defaults.primaryColor200,
  },
};

export const primaryButton = {
  backgroundColor: defaults.vitalityColor,
  backgroundImage: 'none',
  border: `none`,
  boxShadow: 'none',
  color: defaults.primaryColor,
  fontWeight: 400,
  svgColor: defaults.primaryColor,
  textShadow: 'none',
  hover: {
    backgroundColor: defaults.vitalityColorLight,
    backgroundImage: `none`,
  },
  disabled: {
    border: `none`,
    backgroundColor: defaults.vitalityColor100,
    color: defaults.primaryColor200,
    svgColor: defaults.primaryColor200,
  },
};

export const errorButton = {
  backgroundImage: 'none',
  border: `none`,
  boxShadow: 'none',
  textShadow: 'none',
  hover: {
    backgroundColor: defaults.errorColorDark,
    backgroundImage: 'none',
  },
  disabled: {
    backgroundColor: defaults.secondaryColorLight,
    border: `none`,
    color: defaults.white,
    svgColor: defaults.white,
  },
};

export const linkButton = {
  disabledColor: defaults.primaryColor200,
  activeColor: defaults.hoverColor,
  hoverColor: defaults.hoverColor,
};
